import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'

import { CenteredFullScreenLayout } from '@/components/layout'
import { useAuth } from '@/contexts'
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'

export default function LandingPage() {
  const { isSignedIn } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (isSignedIn) {
      navigate("/home")
    }
  }, [isSignedIn, navigate])

  return (
    <CenteredFullScreenLayout>
      <Card className="mx-4 w-full max-w-sm bg-card/90 backdrop-blur supports-[backdrop-filter]:bg-card/80">
        <CardHeader className="text-center pb-2">
          <CardTitle className="text-3xl leading-tight">KitchenMix</CardTitle>
          <CardDescription className="text-base">
            Collaborate on recipes, organize ingredients, and shop smarter together
          </CardDescription>
        </CardHeader>
        <CardContent className="text-center text-sm text-muted-foreground pb-2">
          Your culinary journey starts here
        </CardContent>
        <CardFooter className="pt-2">
          <Button
            onClick={() => navigate('/signin')}
            className="w-full"
          >
            Get Started
          </Button>
        </CardFooter>
      </Card>
    </CenteredFullScreenLayout>
  )
}
